// extracted by mini-css-extract-plugin
export default {"container":"Photos_container__xSu4C","photos":"Photos_photos__iMC+q","photo":"Photos_photo__7vk-Z","hidden":"Photos_hidden__itYDg"};